import type Picker from "emoji-picker-element/picker";

let loading: Promise<Picker> | null = null;

/**
 * O seletor de emojis (emoji-picker-element), em portugues e com os dados
 * servidos pelo proprio app em vez do CDN padrao. A biblioteca e os ~400 KB
 * de dados so carregam na primeira abertura; depois o mesmo elemento e
 * reaproveitado (ele guarda os dados e os recentes no IndexedDB).
 */
export function loadEmojiPicker(): Promise<Picker> {
  loading ??= Promise.all([
    import("emoji-picker-element/picker"),
    import("emoji-picker-element/i18n/pt_BR"),
    import("emoji-picker-element-data/pt/cldr/data.json?url"),
  ]).then(([{ default: PickerElement }, { default: i18n }, { default: dataSource }]) => {
    const picker = new PickerElement({ locale: "pt", dataSource, i18n });
    picker.classList.add("dark");
    return picker;
  });
  // uma falha (rede) nao pode travar as proximas tentativas
  loading.catch(() => {
    loading = null;
  });
  return loading;
}
